import React from "react";
import "./LoadingIcon.css";

function LoadingIcon() {
  return (
    <div data-testid="loading" id="loader-wrapper">
      <div id="loader"></div>
    </div>
  );
}

export default LoadingIcon;
